const HIDDEN_BASE_SYSTEM_SERVICE_IDS = ['lechun-ipweb']

export const filterVisibleBaseSystems = (systemList = []) => {
    return (systemList || []).filter(item => !HIDDEN_BASE_SYSTEM_SERVICE_IDS.includes(item.serviceId))
}
